import { useTheme } from '@mui/material';
import React,{ SVGProps } from 'react';

export const CrossIcon = (props: SVGProps<SVGSVGElement>) => {
	const theme = useTheme()
	let fill = props.fill || theme.palette.primary.main;
	return (
		<svg {...props} width='19' height='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				opacity='1'
				d='M2.20711 0.792893C1.81658 0.402369 1.18342 0.402369 0.792893 0.792893C0.402369 1.18342 0.402369 1.81658 0.792893 2.20711L2.20711 0.792893ZM16.7929 18.2071C17.1834 18.5976 17.8166 18.5976 18.2071 18.2071C18.5976 17.8166 18.5976 17.1834 18.2071 16.7929L16.7929 18.2071ZM0.792893 16.7929C0.402369 17.1834 0.402369 17.8166 0.792893 18.2071C1.18342 18.5976 1.81658 18.5976 2.20711 18.2071L0.792893 16.7929ZM18.2071 2.20711C18.5976 1.81658 18.5976 1.18342 18.2071 0.792893C17.8166 0.402369 17.1834 0.402369 16.7929 0.792893L18.2071 2.20711ZM0.792893 2.20711L16.7929 18.2071L18.2071 16.7929L2.20711 0.792893L0.792893 2.20711ZM2.20711 18.2071L18.2071 2.20711L16.7929 0.792893L0.792893 16.7929L2.20711 18.2071Z'
				fill={fill}
			/>
		</svg>
	);
};
